import { render, staticRenderFns } from "./StudentLabel.vue?vue&type=template&id=342d2660&scoped=true&"
import script from "./StudentLabel.vue?vue&type=script&lang=js&"
export * from "./StudentLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342d2660",
  null
  
)

export default component.exports